import { Link } from "react-router-dom";
import { Activity } from "lucide-react";
import type { TopCondition } from "../../types";
import { Card } from "../Card";
import { initials } from "../../utils/format";

interface TopConditionsCardProps {
  groupId: string;
  conditions: readonly TopCondition[];
  children?: never;
}

export function TopConditionsCard({ groupId, conditions }: TopConditionsCardProps) {
  return (
    <Card title="Top Conditions" icon={Activity}>
      {conditions.length === 0 && <p className="text-sm text-gray-600">No conditions assigned yet.</p>}
      {conditions.length > 0 && (
        <ol className="space-y-3">
          {conditions.map((condition) => (
            <li key={condition.conditionId} className="flex items-center justify-between gap-3">
              <div className="min-w-0">
                <p className="truncate text-sm font-medium text-gray-800">{condition.conditionName}</p>
                <p className="text-xs text-gray-500">{condition.totalDebits} debits</p>
              </div>
              <ul className="flex -space-x-1" aria-label={`Members with ${condition.conditionName}`}>
                {condition.members.map((member) => (
                  <li key={member.memberId}>
                    <Link to={`/uw/groups/${groupId}/members/${member.memberId}`} title={member.fullName} aria-label={member.fullName} className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-white bg-brand-navy text-[11px] font-semibold text-white focus:outline-none focus:ring-2 focus:ring-brand-green-50">
                      {initials(member.fullName.split(" ")[0] ?? "", member.fullName.split(" ").slice(1).join(" "))}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ol>
      )}
    </Card>
  );
}
